import { render, staticRenderFns } from "./OrganizationPacketList.vue?vue&type=template&id=00384498&"
import script from "./OrganizationPacketList.vue?vue&type=script&lang=ts&"
export * from "./OrganizationPacketList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports